import { Button, Form, notification, Spin } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import {
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  CloseOutlined,
  RadiusSettingOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Utils from "utils";
import MediTable from "components/Custom";
import EditableCell from "components/EditableCell";
import {
  getHoadonChiTiet,
  updateHoadonChiTiet,
} from "store/slices/sale/nhapxuatSlice";
import { isEmpty } from "lodash";
import ModelChuyenDoiDonVi from "views/app-views/sale/category/Dmthuocvattu/modelDonViChuyenDoi";

export const initHoSo = {
  action: "initial",
  isRequired: true,
};

const ImportInvoiceDetail = ({ invoice_id, dmThuocVatTuList }) => {
  const dispatch = useDispatch();

  const [visibleModal, setVisibleModal] = useState(false);
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [mahh, setMahh] = useState(null);
  const [record, setRecord] = useState(null);
  const { importHoadonDetailList, loading } = useSelector(
    (state) => state.nhapXuatSale,
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isEditing = (record) =>
    record.action === "initial"
      ? record.action === editingKey
      : record.id === editingKey;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const edit = (record) => {
    form.setFieldsValue({
      maHangErp: null,
      losx: null,
      hanDung: null,

      ...record,

      hanDung: record.hanDung ? moment(record.hanDung) : null,
    });
    setEditingKey(record.action === "initial" ? record.action : record.id);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = importHoadonDetailList.slice(0);
      const index = newData.findIndex((item) =>
        item.id ? item.id === key : item.action === key,
      );
      const item = newData[index];

      // if (item?.maHangErp === null || item?.maHangErp === 0) {
      //     notification.error({ message: "Thông báo", description: "Vui lòng nhập tên hàng ERP" })
      //     return;
      // }

      const payload = {
        id: item?.id || null,
        losx: item?.losx,
        handung: item?.handung,
        maHangErp: item?.maHangErp,
        ...row,
        hanDung: row.hanDung ? row.hanDung.format("YYYY-MM-DD") : null,
        onSuccess: (data) => {
          setEditingKey("");
          dispatch(getHoadonChiTiet({ id: invoice_id }));
        },
      };

      dispatch(updateHoadonChiTiet(payload));
    } catch (error) {}
  };

  useEffect(() => {
    if (isEmpty(invoice_id)) return;
    dispatch(getHoadonChiTiet({ id: invoice_id }));
  }, [dispatch, invoice_id]);

  const Footer = () => {
    let tongCong = 0;

    return <h5>Tổng cộng: {Utils.formatterNumber(tongCong)}</h5>;
  };

  const tableColumns = useMemo(
    () => [
      {
        title: "STT",
        align: "center",
        render: (_, __, index) => index + 1,
        width: "50px",
      },
      {
        title: "Tên hàng",
        dataIndex: "tenHang",
        width: "250px",
      },
      {
        title: "Tên hàng ERP",
        dataIndex: "maHangErp",
        editable: true,
        width: "450px",
        inputType: "select",
        //onChange: (e) => onChangeDT(e),
        options: dmThuocVatTuList?.map((m) => ({
          value: m.mahh,
          label: `[${m.mathamchieu}] - ${m.tenhh}`,
        })),
        render: (value) =>
          value &&
          `[${dmThuocVatTuList?.find((x) => x.mahh === value)?.mathamchieu}]-${dmThuocVatTuList?.find((x) => x.mahh === value)?.tenhh}`,
      },
      {
        title: "ĐVT",
        dataIndex: "dvt",
        width: "50px",
      },
      {
        title: "Lô SX",
        dataIndex: "losx",
        editable: true,
        width: "120px",
      },
      {
        title: "Hạn SD",
        dataIndex: "hanDung",
        inputType: "date",
        editable: true,
        width: "150px",
        render: (value, record) => value && Utils.formatDate(value),
      },
      {
        title: "Số lượng",
        dataIndex: "soLuong",
        inputType: "number",
        align: "center",
        width: "80px",
        render: (value, record) =>
          Utils.formatterNumber(record.soLuong, "number", 3),
      },
      {
        title: "Đơn giá",
        dataIndex: "donGia",
        inputType: "number",
        width: "130px",
        align: "right",
        render: (value, record) =>
          Utils.formatterNumber(record.donGia, "number", 3),
      },
      {
        title: "Thành tiền",
        dataIndex: "thanhTien",
        width: "110px",
        align: "right",
        render: (value, record) =>
          Utils.formatterNumber(record.thanhTien, "number", 3),
      },
      {
        title: "Thuế",
        dataIndex: "thue",
        width: "50px",
      },
      {
        title: "Tiền thuế",
        dataIndex: "tienThue",
        width: "50px",
        align: "right",
        render: (value, record) =>
          Utils.formatterNumber(record.tienThue, "number", 3),
      },
      {
        title: "Đơn giá sau thuế",
        dataIndex: "donGiaSauThue",
        inputType: "number",
        width: "130px",
        align: "right",
        render: (value, record) =>
          Utils.formatterNumber(record.donGiaSauThue, "number", 3),
      },
      {
        title: "Thành tiền sau thuế",
        dataIndex: "thanhTienSauThue",
        width: "110px",
        align: "right",
        render: (value, record) =>
          Utils.formatterNumber(record.thanhTienSauThue, "number", 3),
      },
      {
        fixed: "right",
        align: "center",
        width: "120px",
        render: (_, record, index) => {
          const editable = isEditing(record);
          return editable ? (
            <>
              <Button
                onClick={() => save(record?.id || "initial")}
                className="mr-2"
                icon={<SaveOutlined />}
                shape="circle"
              />
              <Button
                onClick={() => setEditingKey("")}
                className="mr-2"
                icon={<CloseOutlined />}
                shape="circle"
              />
            </>
          ) : (
            <>
              <Button
                title={
                  record.action === "initial"
                    ? "Thêm thông tin"
                    : "Sửa thông tin"
                }
                onClick={() => edit(record)}
                className="mr-2"
                icon={
                  record.action === "initial" ? (
                    <PlusOutlined />
                  ) : (
                    <EditOutlined />
                  )
                }
                shape="circle"
              />

              <Button
                title={"Thiết lập đơn vị tính"}
                className="mr-2"
                icon={<RadiusSettingOutlined type="primary" />}
                shape="circle"
                onClick={() => {
                  if (
                    record.maHangErp === null ||
                    record.maHangErp === undefined ||
                    record.maHangErp === 0
                  ) {
                    notification.error({
                      message: "Thông báo",
                      description: "Bạn vui lòng chọn hàng hóa Mapping ERP",
                    });
                    return;
                  }
                  setMahh(record.maHangErp);
                  setVisibleModal(true);
                  setRecord(
                    dmThuocVatTuList.find((f) => f.mahh === record.maHangErp),
                  );
                }}
              />
            </>
          );
        },
      },
    ],
    [isEditing, save, edit, dmThuocVatTuList],
  );

  const mergedColumns = tableColumns
    .filter((f) => !f.disable)
    .map((col) => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          title: col.title,
          dataIndex: col.dataIndex,
          editing: isEditing(record),
          inputType: col?.inputType,
          isRequired: col?.isRequired,

          options: col?.options,
        }),
      };
    });

  return (
    <>
      <Spin tip="Đang tải..." spinning={loading}>
        <Form form={form} component={false}>
          <MediTable
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            tableColumns={mergedColumns}
            dataSource={
              // isEmpty(phieuChiId)(
              importHoadonDetailList?.map((x) => ({
                ...x,
              }))
            }
            scroll={{ x: "max-content", y: "400px" }}
            rowKey={(item) => item?.id}
            onRenderFooter={() => Footer()}
            enablePagination={false}
          />
        </Form>
      </Spin>
      <ModelChuyenDoiDonVi
        visibleModal={visibleModal}
        setVisibleModal={setVisibleModal}
        mahh={mahh}
        recordHH={record}
      />
    </>
  );
};

export default ImportInvoiceDetail;
